import "../styles/footer.css";
import linkedInIcon from "../assets/LinkedIn.png";
import instagramIcon from "../assets/Instagram.png";
import twitterXIcon from "../assets/TwitterX.png";
import facebookIcon from "../assets/Facebook.png";
import youTubeIcon from "../assets/YouTube.png";
import cyberEssentialsIcon from "../assets/cyberEssentials.png";
import isoIcon from "../assets/iso.png";
import lawSocietyOfScotlandIcon from "../assets/lawSocietyOfScotland.png";
import sraIcon from "../assets/sra.png";

const Footer = () => {
  return (
    <>
      <div className="footerContainer">
        <p className="text-bold">Follow us on social media to learn more about our cases and values.</p>
        <div className="footerSocialImages">
          <a href="https://www.linkedin.com/company/pogustgoodhead/mycompany/" target="_blank" rel="noreferrer">
            <img src={linkedInIcon} alt="linkedIn" />
          </a>
          <a href="https://www.instagram.com/pogustgoodhead/?hl=en" target="_blank" rel="noreferrer">
            <img src={instagramIcon} alt="instagram" />
          </a>
          <a href="https://twitter.com/pogustgoodhead?lang=en" target="_blank" rel="noreferrer">
            <img src={twitterXIcon} alt="twitterX" />
          </a>
          <a href="https://www.facebook.com/pogustgoodhead/" target="_blank" rel="noreferrer">
            <img src={facebookIcon} alt="Facebook" />
          </a>
          <a href="https://www.youtube.com/channel/UCT2PHwd88SYc6SB4tgutE5Q" target="_blank" rel="noreferrer">
            <img src={youTubeIcon} alt="youTube" />
          </a>
        </div>
        <a href="https://pogustgoodhead.com/" target="_blank" rel="noreferrer">
          <img className="footerLogo mb20 mt20" src="https://mydieselclaim.com/wp-content/uploads/2025/01/pg-logo-black-rgb.png" alt="Pogust Goodhead logo" />
        </a>
        <div className="footerCopy">
          <p className="mb20">Pogust Goodhead (a trading name of PGMBM Law Ltd) SRA License Number 512898.</p>
          <p>
            Pogust Goodhead is authorised and regulated by the Solicitors Regulation Authority and complies with the Solicitors Code of Conduct, a copy of which
            can be located here. VAT No: 974 7183 77.
          </p>
        </div>
        <div className="footerLinks">
          <a href="https://pogustgoodhead.com/gdpr-privacy-policy/" target="_blank" rel="noreferrer">
            Privacy Policy
          </a>
          <a href="https://pogustgoodhead.com/complaints-handling-policy/" target="_blank" rel="noreferrer">
            Complaints Policy
          </a>
          <a href="https://pogustgoodhead.com/accessibility-policy/" target="_blank" rel="noreferrer">
            Accessibility Policy
          </a>
          <a href="https://pogustgoodhead.com/trust-centre/" target="_blank" rel="noreferrer">
            Trust Centre
          </a>
        </div>
        <div className="footerAccreditationImages">
          <div>
            <img src={cyberEssentialsIcon} alt="cyberEssentials" />
          </div>
          <div>
            <img src={isoIcon} alt="iso" />
          </div>
          <div>
            <img src={lawSocietyOfScotlandIcon} alt="lawSocietyOfScotland" />
          </div>
          <a href="https://pogustgoodhead.com/" target="_blank" rel="noreferrer">
            <img src={sraIcon} alt="sra" />
          </a>
        </div>
      </div>
    </>
  );
};

export default Footer;
// Compare this snippet from src/components/InfoCard.js:
